import { render } from "./irrigationController.vue?vue&type=template&id=62885674&scoped=true"
import script from "./irrigationController.vue?vue&type=script&lang=js"
export * from "./irrigationController.vue?vue&type=script&lang=js"

import "./irrigationController.vue?vue&type=style&index=0&id=62885674&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62885674"]])

export default __exports__